import { memo } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import ArchitectureIcon from '@mui/icons-material/Architecture';
import { checkStatus } from "features/transactions/api";
import useTransactionAction from "./useTransactionAction";

const CheckStatus = () => {
    const {
        isLoading,
        transaction,
        request
    } = useTransactionAction();

    const onClick = () => request(() => checkStatus(transaction), {
        shouldNotifyOnSuccess: true
    });

    return (
        <LoadingButton
            data-test-id="transactions.transactionActions.checkStatus"
            startIcon={(
                <ArchitectureIcon />
            )}
            onClick={onClick}
            loading={isLoading}
            variant='outlined'
            size='small'
        >
            Check status
        </LoadingButton>
    );
};

export default memo(CheckStatus);
